import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { EAuditEntity } from '../../api/audit';
import { EUserRole } from '../../types/user';

interface IAuditoriaPage {
	searchQuery: string;
	selectedEntidad: EAuditEntity | 'all';
	selectedRol: EUserRole | 'all';
	dateRange: string;
}

const initialState: IAuditoriaPage = {
	searchQuery: '',
	selectedEntidad: 'all',
	selectedRol: 'all',
	dateRange: 'últimos-30-días',
};

export const auditoriaPageSlice = createSlice({
	name: 'auditoriaPage',
	initialState,
	reducers: {
		setSearchQuery: (state, action: PayloadAction<string>) => {
			state.searchQuery = action.payload;
		},
		setSelectedEntidad: (state, action: PayloadAction<EAuditEntity | 'all'>) => {
			state.selectedEntidad = action.payload;
		},
		setSelectedRol: (state, action: PayloadAction<EUserRole | 'all'>) => {
			state.selectedRol = action.payload;
		},
		setDateRange: (state, action: PayloadAction<string>) => {
			state.dateRange = action.payload;
		},
		resetFilters: (state) => {
			state.searchQuery = '';
			state.selectedEntidad = 'all';
			state.selectedRol = 'all';
			state.dateRange = 'últimos-30-días';
		},
	},
});

export const {
	setSearchQuery,
	setSelectedEntidad,
	setSelectedRol,
	setDateRange,
	resetFilters,
} = auditoriaPageSlice.actions;

export default auditoriaPageSlice.reducer;
